<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1920 1080"
  >
    <defs>
      <radialGradient
        
        id="radial-gradient"
        cx="964.71"
        cy="-299.51"
        r="1356.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.37" stop-color="#0e0a0d" />
        <stop offset="0.44" stop-color="#130a0e" />
        <stop offset="0.52" stop-color="#220c0f" />
        <stop offset="0.61" stop-color="#3a0d11" />
        <stop offset="0.7" stop-color="#5c1015" />
        <stop offset="0.79" stop-color="#871419" />
        <stop offset="0.89" stop-color="#bd181e" />
        <stop offset="0.99" stop-color="#fa1d25" />
        <stop offset="1" stop-color="#ff1d25" />
      </radialGradient>
      <linearGradient
        id="linear-gradient"
        x1="1307.45"
        y1="880.43"
        x2="1307.45"
        y2="756.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.44" stop-color="#0e0a0d" stop-opacity="0" />
        <stop offset="0.62" stop-color="#611116" stop-opacity="0.37" />
        <stop offset="0.81" stop-color="#ac171d" stop-opacity="0.71" />
        <stop offset="0.94" stop-color="#db1b22" stop-opacity="0.92" />
        <stop offset="1" stop-color="#ed1c24" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="14194.22"
        y1="880.59"
        x2="14194.22"
        y2="755.94"
        gradientTransform="matrix(-1, 0, 0, 1, 14806.06, 0)"
        xlink:href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-3"
        x1="965.66"
        y1="547.58"
        x2="965.66"
        y2="674.93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.57" stop-color="#ff3131" />
        <stop offset="0.68" stop-color="#ff3430" />
        <stop offset="0.76" stop-color="#ff3e2f" />
        <stop offset="0.84" stop-color="#ff4e2b" />
        <stop offset="0.9" stop-color="#ff6427" />
        <stop offset="0.97" stop-color="#ff8121" />
        <stop offset="1" stop-color="#ff931e" />
      </linearGradient>
    </defs>
    <rect class="cls-1" y="-217.5" width="1920" height="1080" />
    <rect class="cls-2" y="-217.5" width="1920" height="1080" />
    <path
      class="cls-1"
      d="M20.25-217.5c0,7,.06,23.13.17,30.13,6.39,4.51,14.8,8.94,25.11,13.25h0q.18,6.7.43,13.39c1,.61,2.11,1.21,3.19,1.81q1.49,39,5.27,77.2c1.65,2.08,3.34,4.16,5.07,6.22h0q3.45,33.3,8.6,66a487.79,487.79,0,0,0,37.76,50.23q1.91,9.89,4,19.71,7.56,9.15,15.62,18.13,3.45,15.56,7.27,30.92s3-3.25,4.51-4.89q11.19,12.28,23.21,24.2c.39,1.51.78,3,1.18,4.52q11.14,11.08,23,21.84h0c.47,1.79.93,3.57,1.41,5.35q13.42,12.27,27.71,24.12c8.14-19.53,15.85-38.36,22.59-58.31,2.41-1.08,4.79-2.17,7.17-3.27q5.13,33.72,12.19,66.55,9.22,6.27,18.75,12.36a455.46,455.46,0,0,0,6-73.79q8.55-3.75,16.88-7.63,14.9,6.91,30.42,13.5,3.43,16.5,7.19,32.77,4.18-1.77,8.33-3.57l4.66,2q1.62-16.6,2-33.4,8.29,3.19,16.75,6.33,3.79,19.22,8,38.1l3.85,1.52q2.07,9.31,4.24,18.53,4.08,1.66,8.21,3.3,8.43,36.3,18.3,71.24,3.63,1.6,7.29,3.16,2.07,7.27,4.2,14.49l6.73,2.9q8.24,28.33,17.37,55.67,11.88,5.29,24,10.36,4.2,12.62,8.58,25,5.73,2.42,11.5,4.79,1.39,4,2.81,8,10.1,4.15,20.35,8.14,1.26,3.61,2.53,7.22,5.28,2.07,10.61,4.08A179.61,179.61,0,0,0,532,365.89l-.69-2.33L547.53,349l4,1.24a212.33,212.33,0,0,0,3.39-37.75q15.06-3.45,29.86-7.2,14.81,3.75,29.86,7.2c.43,2.08.85,4.15,1.29,6.22l8.75,2q3,14.91,6.25,29.53,7.2,1.68,14.45,3.27c.85,4,1.69,8,2.56,11.94l6.21,1.37q3.57,16.62,7.34,32.83,6.07,1.37,12.19,2.67Q676.76,416,680,429.45c2,.45,4,.88,6,1.3q8.88,37.59,18.76,72.65,8.43,1.85,16.92,3.56,10.76,40.32,22.68,77,19.53,3.92,39.36,7.15,4.93,17.91,10.1,34.84l3.64.58c15.74,52.65,33,98.07,51.44,135l4.68.14a945.11,945.11,0,0,1,7.2-112.08q4.74.47,9.5.88c.12.65.25,1.3.37,1.95,9.85.88,9,.91,19,1.51q5.34.38,10.7.7l8.63,6.45h113.43l8.63-6.45s4.73-.31,10.71-.74c9.93-.6,9.12-.59,19-1.47.12-.65.25-1.3.37-1.95q4.76-.42,9.5-.88a969.48,969.48,0,0,1,7.2,112.93l3.39-.1C1097,730.65,1111.9,692.6,1125.75,649l2.7-.41q6.65-20.61,13-42.83l2.15-.34q1.05-3.68,2.1-7.4l6.48-1.07q1.44-5,2.87-10.05l3.4-.58c.32-1.11.63-2.22.95-3.34l2.75-.47q5.48,3.48,11.19,6.93,5-.93,10-1.91,7.5-23.09,14.56-47.72l2.31-.47q5.19-18,10.14-36.77l1.93-.38q2.48-9.31,4.87-18.82l19.14-13.52q1.23-4.72,2.44-9.5l15.24-11.2q5.67-21.9,11-44.67l3.4-.76q6.29-26.72,12-54.58l3.8-.82q1.82-8.74,3.57-17.61l3.26-.7q2.5-12.51,4.89-25.23l1.94-.41a238.68,238.68,0,0,0,7.1,33.52q5.06-1.16,10.09-2.35a260.76,260.76,0,0,0,10.14,29.74c2.63-.68,5.26-1.38,7.88-2.08q9.12,7.66,18.4,15.22c1.74-.5,3.47-1,5.2-1.53q7.44-26.71,14.21-54.51,7.21-2,14.37-4.16h0q2.13-8.55,4.19-17.2l1.77-.52q2.09-8.75,4.11-17.6l5-1.43q1.92,7.56,4.21,15.07,4.89-1.49,9.74-3,2.68,9.78,6,19.45l6.78-2.27a354,354,0,0,0,17.17,41.51q6.08-2.34,12.1-4.76.91-2.85,1.81-5.72,9.86-3.92,19.54-8,4.68,13.64,10.65,27.08,17.73-8.13,34.91-16.79,4.1-11.46,8-23.1c2.19-1.1,4.38-2.19,6.55-3.29q16.45-48.56,29.9-100.08c1-.46,2.06-.94,3.09-1.41q9.9-38,18-77.39,3.11-1.25,6.19-2.52,1.72-8.32,3.36-16.72c5-2,9.87-3.88,14.73-5.89.45,1.17.9,2.35,1.36,3.52,6.74-2.84,13.39-5.4,19.95-8.32q4.25,11.41,8.79,22.73c2.34-1.15,4.66-2.24,7-3.41q4.68,11.91,9.71,23.68A446.45,446.45,0,0,0,1672,244.49q4-11.85,7.7-23.85,4.3-3.19,8.56-6.43,10.72-34.62,19.7-70.44l2.94-2.07h0q3.9-15.6,7.45-31.41,3.87-2.6,7.68-5.22,4.9,14.43,10.25,28.7c-.12-2.36-.23-4.71-.32-7.07l2.28-1.78q5.64,15.57,11.79,30.94h0q11.36-41.09,20.18-83.67,2.67-2.18,5.29-4.37,4-19.62,7.47-39.54,4.61-3.48,9.06-7,1.13,5,2.31,10c1-.8,1.93-1.62,2.89-2.43q3.84,16.59,8.21,33,4.92-23.78,9-48c1.22-1.13,2.42-2.26,3.62-3.39q5.38-32.41,9.18-65.53,14.68-10.7,27.35-21.79,2.09-20.46,3.53-41.17,2.64-1.68,5.18-3.37c.09-1.31.18-2.62.26-3.93q7.11-4.53,13.46-9.14.18-3.24.35-6.48,5.79-3.87,10.94-7.8c.92-19.77,1.39-48.78,1.39-68.82H1920V1080H0V-217.5Z"
    />
    <path
      class="cls-3"
      d="M1041.71,653.86c-6,.43-10.71.74-10.71.74l-8.63,6.45H908.94l-8.63-6.45q-5.35-.33-10.7-.7a76.39,76.39,0,0,1,152.1,0Z"
    />
    <path
      class="cls-4"
      d="M1094.17,818.66s77-8.3,159.69-10.82c0,0-95.23-21.88-147.88-27.86,0,0,36-3.17,76.49-3.17-7.39-1.42-19.57-3.67-33.6-5.93-23.07-3.71-51.14-8.39-71.12-8.39l3.39-.1c108.88,0,196.49,13.62,196.49,13.62a124.42,124.42,0,0,0-19.61,1.8c68.58,7.29,217.47,33.83,217.47,33.83-46.75,2.05-67.18,6.82-67.18,6.82,70.56,20.23,128.85,44,128.85,44h-262S1195.51,837.26,1094.17,818.66Z"
    />
    <path
      class="cls-5"
      d="M837.15,817.8s-77-8.3-159.69-10.82c0,0,95.23-21.88,147.88-27.86,0,0-36-3.16-76.49-3.16,7.39-1.42,19.57-3.68,33.6-5.93,23.07-3.71,51.14-8.39,71.12-8.39l-4.68-.14c-108.88,0-195.2,13.66-195.2,13.66A125.1,125.1,0,0,1,673.3,777c-68.58,7.29-217.48,33.83-217.48,33.83,46.76,2.06,67.19,6.82,67.19,6.82-74.4,17.88-152.9,44.9-152.9,44.9h288S727.9,840.52,837.15,817.8Z"
    />
    <path
      class="cls-6"
      d="M1236.14,469.86c.65-3.21,1.38-6.4,2.07-9.6l0-.15.15-.12c4.51-3.47,10.56-8.16,15-11.49l-.32.47c2.46-10.77,5.68-22.67,8.63-33.39q1.49-5.55,2.85-11.14l.05-.18.18-.05,3.39-.78-.24.25c2-9.11,3.63-18.28,5.51-27.4,1.68-8,4-19.43,5.76-27.32l.15-.69.68-.14,3.79-.83-.82.83c.9-4.36,2.8-13.2,3.76-17.56l.13-.58.55-.1,3.26-.65-.63.64c1.74-8.25,3.65-16.89,5.6-25.09l.2,0c-.9,6.09-2.05,12.93-3.08,19-.37,2.29-.8,4.57-1.2,6.85l-.53.12-3.26.76.68-.69c-.82,4.43-2.5,13.25-3.38,17.66l-.14.68-.68.15-3.81.81.82-.82c-3.91,17.92-8.57,36.58-12.72,54.44l0,.2-.21,0-3.41.74.24-.23q-1.38,5.58-2.63,11.2c-2.35,10.87-5,22.9-7.81,33.61l-.07.3-.25.17c-4.47,3.33-10.87,7.65-15.46,10.91l.19-.27c-.94,3.14-1.83,6.28-2.82,9.41l-.19-.05Z"
    />
    <path
      class="cls-7"
      d="M1183.24,587.55c4.51-16,9.79-32.06,14.57-47.89l2.3-.5-.16.15c2.36-9.24,4.76-18.46,7.31-27.65l2.57-9.18.08-.3c.42-.1,1.83-.33,2.23-.41l-.36.33c1.7-6.25,3.43-12.49,5.27-18.71l.1,0c-1.43,6.42-3,12.82-4.54,19.2l-.29.06-1.93.41.38-.35c-3.25,12.14-6.82,24.69-10.41,36.7l0,.13-.13,0-2.32.44.14-.13c-4.69,15.88-8.72,32.4-14.78,47.66Z"
    />
    <path
      class="cls-7"
      d="M1081.09,762.38c18-36.59,32.06-74.94,44.3-113.77l.29,0,2.69-.42-.38.32c3.82-12.66,9.13-30.36,13-42.79l.07-.24c.08,0,2.26-.33,2.4-.36l-.31.27,2.15-7.39.06-.2.21,0,6.48-1-.22.2,3-10,0-.11.12,0,3.41-.53-.11.09,1-3.32,0-.06h0l2.76-.43,0,.1-2.75.51.07-.06-.9,3.35,0,.08-.09,0-3.39.62.15-.13-2.78,10.08-.05.17-.18,0-6.47,1.11.26-.23-2,7.42-.06.23-.24,0-2.15.35.32-.28c-3.63,12.45-9.06,30.29-12.89,42.87l-.08.28-.3.05-2.7.4.38-.33c-12.57,38.57-26.71,77.22-45.11,113.21Z"
    />
    <path
      class="cls-6"
      d="M1356.45,376.89q7.15-27.24,13.54-54.67l.1-.43.45-.14,14.31-4.36-.68.71c1.31-5.65,2.74-11.57,4.24-17.17l.14-.55,2.28-.62-.62.65c1.47-5.84,3-11.67,4.63-17.47l.07-.23.19,0c1.68-.4,3.37-.8,5.06-1.17l.06.19c-1.64.58-3.28,1.13-4.92,1.68l.25-.27c-1.1,5.93-2.32,11.84-3.59,17.73l-.1.49-.51.16-1.77.56.65-.68c-1.29,5.87-2.81,12-4.28,17.78l-.54.15-14.44,4,.56-.57q-3.48,13.65-7.18,27.25t-7.71,27.1l-.19-.06Z"
    />
    <path
      class="cls-6"
      d="M1523,344l7.89-23.15,0-.1.09,0,6.53-3.33c4.85-15.47,10.68-33.28,15.4-49.68q7.4-25.25,13.88-50.76l3.47-1.61-.51.6q2.45-9.63,4.79-19.27c2.71-11.32,6.63-27.44,9.18-38.64l4.39-19.37.07-.32.29-.11,6.22-2.42-.29.35c.91-4.11,2.8-12.52,3.74-16.64l.2,0c-.75,4.23-2.22,12.59-3,16.8l-.05.25-.25.1-6.15,2.62.36-.43q-1.85,9.76-3.9,19.5-6.09,29.42-14,58.43l-3.5,1.57.5-.59c-4.51,16.83-9.25,33.59-14.33,50.26s-10.46,33.32-16.18,49.81l-.11.06-6.57,3.24c.49-.78-8.19,23-8.07,22.9L1523,344Z"
    />
    <path
      class="cls-8"
      d="M1688.11,214.19c6.89-23.5,13.29-47.16,18.93-71l.3-.22,2.93-2.1-.4.59c.59-2.63,1.2-5.24,1.85-7.85,1.75-7.25,4.1-16.2,6.07-23.43l.06-.22.16-.1q3.93-2.49,7.91-4.87l.11.16q-3.69,2.84-7.44,5.57l.21-.32c-1.48,7.38-3.4,16.41-5.1,23.69-.62,2.75-1.28,5.49-2,8.23l-.31.21-3,2,.39-.56c-6.38,23.4-12.77,47.65-20.75,70.17Z"
    />
    <path
      class="cls-8"
      d="M1760.61,114.38c2.18-10.57,6.61-31.77,8.85-42.32l0-.24.2-.17,5.23-4.43-.27.45c1.16-6.6,2.27-13.21,3.49-19.8s2.64-13.15,4.12-19.69l.06-.28c1.62-1.14,3.22-2.31,4.85-3.44,6-4.25,6.46-4.36.52.67-1.46,1.24-2.93,2.45-4.4,3.68l.25-.41q-1.51,10-3.36,19.85c-1.26,6.6-2.65,13.16-4,19.74l0,.28-.22.17-5.34,4.31.24-.41c-2.46,10.48-7.51,31.62-10,42.08l-.2,0Z"
    />
    <path
      class="cls-8"
      d="M1805.29,61.88q4.62-24,8.41-48.06l0-.23.18-.16,3.58-3.43-.22.42q1.27-8.18,2.41-16.36c1.72-12.63,4.06-28.25,6-40.89.45-2.72.87-5.45,1.35-8.17l.2,0c-.16,2.76-.38,5.51-.59,8.26-1.48,18.79-4.62,38.78-8,57.38l0,.25-.18.17-3.65,3.36.21-.39c-1.44,8-2.92,16-4.53,24s-3.29,15.94-5,23.88l-.2,0Z"
    />
    <path
      class="cls-9"
      d="M236.26,126.19l7.1-3.42.31-.15.06.35,3,16.65c3,16.65,7,33.12,9,49.92l-.2.05c-.84-2.71-1.58-5.43-2.28-8.17a250.41,250.41,0,0,1-5.09-24.88c-1.81-11.14-3.56-22.29-5-33.49l.38.21-7.24,3.12-.08-.19Z"
    />
    <path
      class="cls-6"
      d="M184.65,155.05a21.09,21.09,0,0,1,1.42,2.54c.2.43.57.81.54,1.29a2.66,2.66,0,0,1-.51,1.57l-.2.05a2.61,2.61,0,0,1-1.22-1.1c-.26-.41-.13-.93-.16-1.39a21,21,0,0,1,0-2.86l0,0s.14-.14.14-.15Z"
    />
    <path
      class="cls-9"
      d="M132.64,109.38l4.4-5,.17-.19.19.19c7.71,8.09,15.55,16,23.62,23.77l.15.15.07.24,1.27,4.49-.25-.42c7.57,7.18,15.27,14.82,22.39,22.42l-.14.15c-4.21-3.22-8.24-6.66-12.17-10.2s-7.72-7.24-11.39-11.06l-.19-.19,0-.23L159.62,129l.22.39q-5.85-6-11.58-12.15c-3.82-4.09-7.53-8.28-11.22-12.48h.36l-4.62,4.79-.14-.13Z"
    />
    <path
      class="cls-7"
      d="M721.72,507c6.71,25.47,15.11,52.47,22.68,76.73l39.36,7.07.21,0,.06.2L794.2,625.8l-.32-.28,3.63.57.26,0c10.53,34.66,22.26,69,36.27,102.41,4.56,11.1,9.92,22.23,14.8,33q-8.21-16.11-15.37-32.73c-14.41-33.2-26.14-67.49-36.42-102.17l.33.29-3.64-.58-.25-.05-.07-.24-10-34.87.27.24c-.13,0-39.37-7.28-39.5-7.25C736,558.68,728.21,532.69,721.72,507Z"
    />
    <path
      class="cls-6"
      d="M615.94,318.61l8.76,1.93.11,0s6.49,29.55,6.47,29.58l-.28-.28L645.47,353l.3.06.07.31,2.62,11.92-.41-.42,6.21,1.34.36.07.09.37,7.51,32.78-.57-.57,12.19,2.6.52.11.12.52,6.49,27.1-.76-.75c.17,0,6.66,1.44,6.63,1.41,2.6,10.91,6.28,26.33,8.93,37.1,2.22,9,6.8,27.36,9.07,36.4l-.19.05q-5.6-17.91-10.45-36.05C691,455.3,687.83,443.18,685,431l.79.77-6-1.32-.62-.14-.14-.61-6.15-27.2.63.63-12.18-2.74-.47-.11-.1-.46-7.17-32.88.44.44-6.2-1.4-.35-.08-.07-.34-2.49-12,.37.37-14.44-3.37-.23,0-.05-.23-6-29.58.12.12-8.73-2.05,0-.19Z"
    />
    <path
      class="cls-6"
      d="M584.79,305.19c4.48.87,10.68,2.08,15.07,3,5,1.08,10.08,1.83,15,3.46l.57.18a62.35,62.35,0,0,1,.63,6.83l-.2.05a59.89,59.89,0,0,1-2-6.07l.63.64c-7.58-1.32-14.88-3.86-22.31-5.8l-7.39-2.12,0-.19Z"
    />
    <path
      class="cls-10"
      d="M1041.71,653.86c-6,.43-10.71.74-10.71.74l-8.63,6.45H908.94l-8.63-6.45q-5.35-.33-10.7-.7a76.39,76.39,0,0,1,152.1,0Z"
    />
    <path
      class="cls-11"
      d="M20.48-187.45c7.79,5.4,16.41,9.48,25.14,13.12l.14.06v.15l.5,13.38-.15-.24,3.19,1.79.16.09v.17c1,25.18,3.31,53.07,5.46,76.82L60-75.92l.13.16,0,.2C62.33-54.14,65.87-29.87,68.87-10Q77.51,3,87,15.55c6.32,8.44,13,16.64,19.74,24.71l0,.25,3.84,19.72c4,4.15,10.49,12.43,15.25,17.91,2.32,9.25,4.81,21.89,6.94,31.28l-.2,0-3.9-15.4c-1.11-4.61-3-11.56-3.7-15.16-5.28-6-10.58-12-15.82-18l-.13-.14,0-.21-4.1-19.7c-5.55-5.8-13.61-16.29-19.59-24.06C79,8.34,72.92-.32,67.2-9.21q-5-33-8.38-66.22l.16.36-5.06-6.25-.12-.14q-3.7-38.64-5-77.44l.16.26-3.18-1.83-.15-.08v-.16l-.37-13.4.15.21c-4.37-1.85-8.68-3.84-12.89-6a104.5,104.5,0,0,1-12.19-7.34l.12-.17Z"
    />
    <path
      class="cls-9"
      d="M366.7,138.12l8.21,38-.18-.22,3.86,1.5.16.06c0,.09,4.36,18.56,4.37,18.68l-.25-.3,8.22,3.26.23.09.06.24c5.1,22.94,13.09,50.13,18.15,70.64l7.29,3.13.35.15.1.37,4.27,14.46-.49-.55,6.74,2.86.4.17c5.37,18.2,11.63,37.93,17.55,56l-.53-.59,23.9,10.53.34.14.11.34,8.28,25.08-.26-.28L489,387l.11,0,0,.11,2.66,8.08-.19.07-3-8,.14.15-11.59-4.58-.19-.08-.07-.2-8.88-24.92.44.48-24.09-10.19-.38-.17-.15-.42c-6.27-18.41-12-37-17.31-55.72l.51.58-6.72-2.94-.38-.16-.11-.39-4.13-14.52.46.52-7.29-3.2-.33-.14-.1-.35c-6.21-23-13.4-49.14-17.74-71l-8.19-3.34-.21-.09,0-.21-4.15-18.55.2.23-3.84-1.54-.16-.06,0-.16c.2,0-8.27-38.47-7.62-38.18Z"
    />
    <path
      class="cls-9"
      d="M297.34,120.41c7.87,3.25,23.23,9.68,31.06,13,2,8,4.13,16.93,5.39,25,.38,2.41,1,5.91,1.22,8.32l-.2.05c-1.7-5.25-3.17-10.84-4.47-16.2-1.11-4.55-2.5-11.78-3.4-16.43l.47.57c-7.53-3.48-22.66-10.58-30.15-14.14l.08-.19Z"
    />
    <path
      class="cls-12"
      d="M858.2,672.44c.58-5.72,1.62-17.21,2.22-22.92l0-.33.35,0,9.51.75.36,0,.07.36.39,1.94-.45-.41c8.46.82,21.05,1.5,29.67,2l.22,0,.19.13,8.68,6.38-.5-.17c28.27-.15,85.16-.15,113.43,0l-.51.17,8.68-6.39.19-.13c10-.64,19.94-1.07,29.9-2l-.47.43.39-1.95.08-.38.37,0,9.51-.76.38,0,0,.37c.79,8.37,1.6,16.74,2.33,25.11-1.07-8.34-2.07-16.68-3.09-25l.42.33-9.5,1,.46-.41c0,.27-.4,2.09-.43,2.34l-.39,0c-9.86,1.06-19.79,1.66-29.68,2.45l.41-.15-8.58,6.51c-28.39.63-85.45.14-113.94.16h-.28l-.22-.17-8.58-6.52.4.15c-8.77-.63-21.4-1.52-30-2.49l-.07-.37-.34-2,.43.39-9.5-1,.39-.3c-.67,5.69-2.21,17.15-2.92,22.83Z"
    />
    <rect class="cls-13" y="-217.5" width="1920" height="1080" />
  </svg>
</template>

<script>
export default {
  name: "SunsetSvg",
};
</script>

<style>
.cls-1 {
  fill: #0e0a0d;
}
.cls-2 {
  fill: url(#radial-gradient);
}
.cls-3 {
  fill: #ff3131;
}
.cls-4 {
  fill: url(#linear-gradient);
}
.cls-5 {
  fill: url(#linear-gradient-2);
}
.cls-6 {
  fill: #751017;
}
.cls-7 {
  fill: #ed1c24;
}
.cls-8 {
  fill: #931521;
}
.cls-9 {
  fill: #8e0e21;
}
.cls-10 {
  fill: url(#linear-gradient-3);
}
.cls-11 {
  fill: #c11a2e;
}
.cls-12 {
  fill: #ff4a4a;
}
.cls-13 {
  fill: none;
}

</style>

